import React from 'react';
import '../App.css';
import privacyImage from '../assets/privacy.avif';
import Footer from '../components/Footer';

const PrivacyPolicy = () => {
  return (
    <div className="calisthenics-page">
      {/* Hero Section */}
      <div
        className="calisthenics-banner"
        style={{ backgroundImage: `url(${privacyImage})` }}
      >
        <div className="banner-overlay"></div>
        <h2>PRIVACY POLICY</h2>
      </div>

      {/* Privacy Policy Content */}
      <div className="container blog-margin mt-5">
        <div className="blog-content mt-5">
          {/* Effective Date - Aligned with content */}
          <div className="date-section mb-4">
            <h3 className="date" style={{ fontSize: '1.2rem' }}>Effective Date: March 31, 2026</h3>
          </div>

          <p className="blog">
            <strong>Core Flow Fit</strong> (“we”, “our”, or “us”) respects your privacy and is committed to protecting your
            personal data. This Privacy Policy explains how we collect, use, store, and protect your information
            when you use the Core Flow Fit mobile application, website, and related services (collectively
            referred to as the “Service”).
          </p>

          <div>
            <h6 className="blog-h mt-3">1. Information We Collect</h6>
            <p className="blog mt-2"><strong>Personal Information:</strong></p>
            <ul className="blog mt-2">
              <li>Name and Email address</li>
              <li>Account login credentials</li>
              <li>Any information you voluntarily provide when creating an account</li>
            </ul>
            <p className="blog mt-2"><strong>Usage Data:</strong></p>
            <ul className="blog mt-2">
              <li>Workout activity and progress within the app</li>
              <li>Interaction with training programs and content</li>
              <li>Time spent within the application</li>
            </ul>
            <p className="blog mt-2"><strong>Device & Technical Data:</strong></p>
            <ul className="blog mt-2">
              <li>Device type, model, and operating system version</li>
              <li>IP address and mobile device identifiers</li>
              <li>Crash reports and performance analytics</li>
            </ul>
          </div>

          <div>
            <h6 className="blog-h mt-3">2. How We Use Your Information</h6>
            <ul className="blog mt-2">
              <li>Create and manage your user account</li>
              <li>Provide fitness training programs and personalised content</li>
              <li>Improve application performance and functionality</li>
              <li>Monitor usage patterns to enhance user experience</li>
              <li>Communicate service updates or important notices</li>
              <li>Ensure the security and integrity of the platform</li>
            </ul>
          </div>

          <div>
            <h6 className="blog-h mt-3">3. Legal Basis for Processing (GDPR – UK & EU Users)</h6>
            <p className="blog mt-2">
              We process personal data based on legitimate interests, user consent, and the necessity to provide
              services requested by the user. Users may withdraw consent at any time by contacting us.
            </p>
          </div>

          <div>
            <h6 className="blog-h mt-3">4. Data Storage and Security</h6>
            <p className="blog mt-2">
              We implement appropriate technical and organisational security measures to protect your data from
              unauthorised access, loss, misuse, or alteration. While we strive to protect personal information, no
              internet-based service can guarantee absolute security.
            </p>
          </div>

          <div>
            <h6 className="blog-h mt-3">5. Third-Party Services</h6>
            <p className="blog mt-2">
              The Core Flow Fit app may use trusted third-party services such as analytics providers, cloud
              hosting platforms, or payment processors. These services are governed by their own privacy policies.
            </p>
          </div>

          <div>
            <h6 className="blog-h mt-3">6. Data Sharing</h6>
            <p className="blog mt-2">
              We do not sell, trade, or rent your personal information to third parties. Information may only be
              disclosed when required by law or when necessary to protect the rights, safety, or security of our
              users or the platform.
            </p>
          </div>

          <div>
            <h6 className="blog-h mt-3">7. User Rights</h6>
            <ul className="blog mt-2">
              <li>Request access to the personal data we hold about you</li>
              <li>Request correction of inaccurate information</li>
              <li>Request deletion of your personal data</li>
              <li>Withdraw consent to data processing or request restriction</li>
            </ul>
          </div>

          <div>
            <h6 className="blog-h mt-3">8. Data Retention</h6>
            <p className="blog mt-2">
              We retain personal data only for as long as necessary to provide services and comply with legal
              obligations. Users may request account deletion at any time.
            </p>
          </div>

          <div>
            <h6 className="blog-h mt-3">9. Children’s Privacy</h6>
            <p className="blog mt-2">
              Core Flow Fit is intended for individuals aged 16 and above. We do not knowingly collect personal
              information from children under 16.
            </p>
          </div>

          <div>
            <h6 className="blog-h mt-3">10. International Data Transfers</h6>
            <p className="blog mt-2">
              If data is transferred outside the UK or EEA, appropriate safeguards will be implemented to ensure 
              user data remains protected.
            </p>
          </div>

          <div>
            <h6 className="blog-h mt-3">11. Changes to This Privacy Policy</h6>
            <p className="blog mt-2">
              We may update this Privacy Policy periodically. Updated versions will be posted within the
              application and on our website.
            </p>
          </div>

          <div>
            <h6 className="blog-h mt-3">12. Contact Information</h6>
            <p className="blog mt-2">
              For any questions regarding this Privacy Policy or data requests, please contact: <br />
              <strong>Core Flow Fit</strong> <br />
              Email: <a 
                href="mailto:infocoreflowfit@gmail.com" 
                style={{ color: 'white', textDecoration: 'underline' }}
              >
                infocoreflowfit@gmail.com
              </a>
            </p>
          </div>

          <p className="bold mt-5 mb-5">
            Thank you for trusting Core Flow Fit with your fitness journey and personal information.
          </p>
        </div>
      </div>
      <Footer/>
    </div>
  );
};

export default PrivacyPolicy;